import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NotesService as CmsApiNotesService } from '../../../core/cms-api/services/notes.service';
import { NoteDto, NoteDtoResult } from '../../../core/cms-api/models';
import { NotesPost$Params } from '../../../core/cms-api/fn/notes/notes-post';

@Injectable({
  providedIn: 'root',
})
export class NotesService {

  private apiNotesService = inject(CmsApiNotesService);

  saveNewNote(data:NoteDto): Observable<NoteDtoResult>{
    return this.apiNotesService.notesPost({ body: data} as  NotesPost$Params);
  }
}
